import { Box, Icon, Modal, ModalHeader, Text } from '@bechtel/gds';
import styled, { css } from 'styled-components';

export const TableStyled = styled.table`
  text-align: left;
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  min-width: 1200px;
  height: max-content;
  ${({ theme }) => css`
    td,
    th {
      border: 1px solid ${theme.colors.grey[200]};
      padding: ${theme.spacings[400]};
      border-collapse: separate;
      vertical-align: middle;
      div {
        vertical-align: middle;
      }
    }
    th {
      background: ${theme.colors.grey[100]};
      vertical-align: middle;
      font-size: ${theme.fontSizes[300]};
      font-weight: 600;
      height: 40px;
      position: sticky;
      left: 0;
      top: 0;
      min-width: 100px;
    }
    td {
      font-size: ${theme.fontSizes[400]};
      &:first-child,
      &:last-child {
        background: ${theme.colors.white};
      }
    }
  `}
`;

export const CommentIconStyled = styled(Box)`
  cursor: pointer;
`;

export const TableRowHeaderStyled = styled.tr`
  ${({ theme }) => css`
    background: ${theme.colors.grey[100]};
  `}
`;

export const LockIconStyled = styled(Box).attrs({ ml: { sm: '400' } })<{ hasPermission: boolean }>`
  ${({ hasPermission }) => {
    return css`
      cursor: ${hasPermission ? 'pointer' : 'not-allowed'};
    `;
  }}
}
`;

export const LockIcon = styled(Icon)<{ canLockToolRoom: boolean; isLocked: boolean }>`
  ${({ canLockToolRoom, isLocked, theme }) => {
    const color = canLockToolRoom || isLocked ? theme.colors.blue[800] : theme.colors.grey[400];
    return css`
      &:hover {
        color: ${color};
      }
    `;
  }}
`;

export const ToolCatalogTitleStyled = styled(Text).attrs({
  color: 'blue.800',
  weight: '600',
  size: '450',
  family: 'openSansSemiBold',
})`
  line-height: 1.5;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
`;

export const ActiveRequisitionWrapper = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-grow: 1;
    overflow: auto;
    max-height: 100%;
    max-width: calc(100vw - 95px);
  `}
`;

export const StickyColumnStyled = styled.td`
  ${() =>
    css`
      position: sticky;
      top: 0;
    `}
`;

interface ToolRoomTdStyledProps {
  isUpdated: boolean;
  isLocked: boolean;
}

export const ToolRoomTdStyled = styled.td<ToolRoomTdStyledProps>`
  ${({ isLocked, theme }) => {
    return css`
      background: ${isLocked && `${theme.colors.yellow[100]} !important`};
    `;
  }}
  ${({ isUpdated, theme }) => {
    return css`
      background: ${isUpdated ? theme.colors.blue[100] : theme.colors.white};
    `;
  }}
`;

export const ModalFooterStyled = styled.div`
  ${({ theme }) => css`
    background-color: ${theme.colors.white};
    padding: ${theme.spacings[500]};
  `}
`;

export const ModalStyled = styled(Modal)`
  width: 550px;
  min-height: 230px;
`;

export const ModalHeaderStyled = styled(ModalHeader)`
  ${({ theme }) => css`
    background-color: ${theme.colors.white};
    color: ${theme.colors.black};
    border-bottom: 1px solid ${theme.colors.grey[300]};
    padding-top: ${theme.spacings[600]};
    padding-bottom: ${theme.spacings[550]};
    font-family: opensanssemibold;
    & > h1 {
      font-size: ${theme.fontSizes[500]};
    }
  `};
`;

export const CommentContainerStyled = styled(Box).attrs({
  justifyContent: { sm: 'flex-end' },
})`
  width: 100%;
  height: 15px;
`;

export const ReqFooterStyled = styled(Box).attrs({ p: { sm: '500' }, justifyContent: { sm: 'flex-end' } })`
  ${({ theme }) => {
    return css`
      box-shadow: 0 -2px 4px 0 rgba(0, 0, 0, 0.2);
    `;
  }}
`;

export const InputFieldStyled = styled.input`
  ${({ theme }) => {
    return css`
      border: none;
      background: transparent;
      border-radius: ${theme.radii[200]};
      padding-right: ${theme.spacings[200]};
      padding-left: ${theme.spacings[200]};
      margin-bottom: ${theme.spacings[300]};
      :focus {
        border: none;
        box-shadow: rgba(66, 153, 225, 0.6) 0px 0px 0px 3px;
        outline: 0;
      }
      height: 26px;
    `;
  }}
`;
